import { render } from "./CheckMark.vue?vue&type=template&id=5c0489a0&scoped=true"
import script from "./CheckMark.vue?vue&type=script&lang=js"
export * from "./CheckMark.vue?vue&type=script&lang=js"

import "./CheckMark.vue?vue&type=style&index=0&id=5c0489a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0489a0"]])

export default __exports__